exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loaderUI{top:60px;right:20px}", ""]);

// exports
